module.exports = __webpack_public_path__ + "img/114-Vert Mousse.jpg";